import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const RevisionHistory = ({ versions, loading, currentDrawingId }) => {
  const { t } = useLanguage();

  return (
    <div className="bg-surface rounded-lg border border-border p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="GitBranch" size={16} className="text-accent" />
        <h3 className="text-sm font-semibold text-text-primary">{t('revisionHistory')}</h3>
        {versions?.length > 0 && (
          <span className="ml-auto text-xs bg-accent/10 text-accent px-2 py-0.5 rounded-full">
            {versions?.length} {versions?.length !== 1 ? t('revisions') : t('revision')}
          </span>
        )}
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-6">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-accent"></div>
        </div>
      ) : versions?.length === 0 ? (
        <p className="text-sm text-text-secondary text-center py-4">{t('noRevisionsFound')}</p>
      ) : (
        <div className="space-y-2">
          {versions?.map((v) => (
            <div
              key={v?.id}
              className={`flex items-center gap-3 p-3 rounded-lg border transition-colors ${
                v?.id === currentDrawingId
                  ? 'border-accent bg-accent/5' :'border-border hover:bg-background'
              }`}
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                v?.is_latest ? 'bg-accent text-white' : 'bg-gray-100 text-text-secondary'
              }`}>
                {v?.revision || `R${v?.version_number}`}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-text-primary">
                    {t('version')} {v?.version_number}
                  </span>
                  {v?.is_latest && (
                    <span className="text-xs bg-green-100 text-green-700 px-1.5 py-0.5 rounded">{t('latest')}</span>
                  )}
                  {v?.id === currentDrawingId && (
                    <span className="text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded">{t('viewing')}</span>
                  )}
                </div>
                <p className="text-xs text-text-secondary mt-0.5">
                  {v?.upload_date
                    ? new Date(v.upload_date)?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                    : v?.created_at
                    ? new Date(v.created_at)?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                    : '—'}
                  {v?.uploaded_by_profile?.full_name && (
                    <span className="ml-2">{t('by')} {v?.uploaded_by_profile?.full_name}</span>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RevisionHistory;
